module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs2":"fusioncharts","commonjs":"fusioncharts","amd":"fusioncharts","root":"FusionCharts"}
// module id = 4
// module chunks = 0 1